import '../shared/index';
import './components';
import './stores';
import railsDateToChronometer from '../../auto/utils/railsDateToChronometer';
import autoServiceApi from '../../auto/utils/autoServiceApi';

window.autoServiceApi = autoServiceApi;
window.railsDateToChronometer = railsDateToChronometer;
